import { render, staticRenderFns } from "./[...slug].vue?vue&type=template&id=153c1e5c&scoped=true&"
import script from "./[...slug].vue?vue&type=script&lang=ts&setup=true&"
export * from "./[...slug].vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./[...slug].vue?vue&type=style&index=0&id=153c1e5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c1e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153c1e5c')) {
      api.createRecord('153c1e5c', component.options)
    } else {
      api.reload('153c1e5c', component.options)
    }
    module.hot.accept("./[...slug].vue?vue&type=template&id=153c1e5c&scoped=true&", function () {
      api.rerender('153c1e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/[...slug].vue"
export default component.exports